import EmptyState from "../UI/EmptyState";
import FraseRespuestaRow from "./FraseRespuestaRow";

const FrasesRespuestaTable = ({ frasesRespuesta, search }) => {
  if (!frasesRespuesta || frasesRespuesta.length === 0) {
    return (
      <EmptyState
        icon={search ? "mdi:magnify-remove-outline" : "mdi:message-reply-text-outline"}
        title={
          search ? "No se encontraron frases respuesta" : "No hay frases respuesta para mostrar"
        }
        description={search ? "Intenta con otra búsqueda" : null}
      />
    );
  }

  return (
    <div className="table-responsive scroll-sm">
      <table
        className="table bordered-table mb-0"
        style={{ minWidth: "1000px" }}
      >
        <thead>
          <tr>
            <th scope="col" style={{ minWidth: "300px" }}>
              Frase
            </th>
            <th scope="col" style={{ minWidth: "100px" }}>
              Valor
            </th>
           
            <th scope="col" style={{ minWidth: "80px" }}>
              Acciones
            </th>
          </tr>
        </thead>
        <tbody>
          {frasesRespuesta.map((fraseRespuesta) => (
            <FraseRespuestaRow key={fraseRespuesta.id} fraseRespuesta={fraseRespuesta} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FrasesRespuestaTable;
